'use client';

import { useEffect } from 'react';
import { captureInstallEvent } from '@/lib/install-capture';

// Catches the browser's install offer early (lib/install-capture.ts). Draws nothing.
export default function InstallCapture() {
  useEffect(() => captureInstallEvent(), []);
  return null;
}
